import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: #101522;
`;

export const FooterWrapper = styled.div`
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    padding: 12px 15px;
  }

  @media screen and (max-width: 480px) {
    padding: 10px 12px;
  }
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
  @media screen and (max-width: 820px) {
    padding-top: 16px;
  }

  @media screen and (max-width: 480px) {
    padding-top: 10px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 768px) {
    align-items: center;
    text-align: center;
  }

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 600;
  margin-bottom: 20px;
  @media screen and (max-width: 480px) {
    font-size: 15px;
    margin-bottom: 10px;
  }
`;

export const FooterLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;

  &:hover {
    color: #01bf71;
    transition: 0.3s ease-out;
  }

  @media screen and (max-width: 480px) {
    font-size: 13px;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 20px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    margin: 15px auto 0 auto;
    gap: 10px;
  }

  @media screen and (max-width: 480px) {
    margin: 12px auto 0 auto;
    gap: 8px;
  }
`;

export const SocialLogo = styled(Link)`
  color: #fff;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: bold;

  img {
    @media screen and (max-width: 480px) {
      width: 100px !important;
    }
  }
`;

export const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 8px;

  @media screen and (max-width: 480px) {
    font-size: 12px;
    text-align: center;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
`;

export const SocialIconLink = styled.a`
  font-size: 14px;
`;
